import React, { useEffect, useState } from 'react'
import Spacer from '../components/general/Spacer'
import { Box } from 'rebass/styled-components'
import SwiperVariable from '../components/swiper/Variable'

const Carousel = ({ options, data }) => {
    const [media, setMedia] = useState([])
    useEffect(() => {
        let output = []
        if (options.media && options.media.set && options.media.set.length) {
            output = options.media.set
        } else if (data.media && data.media.gallery && data.media.gallery.images && data.media.gallery.images.length) {
            output = data.media.gallery.images
        }
        setMedia(output)
    }, [options, data])
    const float = (options.float) ? { float: 'left' } : {}
    const autoplay = (typeof options.autoplay !== 'undefined' && options.autoplay === 'true') ? true : false
    const slider = (typeof options.slider !== 'undefined' && options.slider === 'true') ? true : false

    return (
        <>
            {media.length ?
                <Spacer spacing={ (options && options.spacing) || {} } width={['100%', '100%', '100%', options.width]} height={options.height} sx={float}>
                    <SwiperVariable set={media} autoplay={autoplay} slider={slider} />
                </Spacer> :
                null
            }
        </>
    )
}

export default Carousel
